import { Translate, TranslateHtml } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { BadgeScore } from 'src/app/shared/components/badgeScore';
import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { usePetitionStrengthScore } from './hooks/usePetitionStrengthScore';

export function PetitionStrengthScore() {
	const { data, actions } = usePetitionStrengthScore();

	return (
		<Flex
			sx={{
				alignItems: 'center',
				justifyContent: 'center',
				width: '100%',
				padding: ['24px', '20px'],
				borderWidth: ['0 0 0', '0 0 0 1px'],
				borderStyle: ['none none none', 'none none none solid'],
				borderColor: 'neutral-grey100',
			}}
		>
			<Flex sx={{ gap: 24, alignItems: ['center'], flexDirection: 'column' }}>
				<Flex sx={{ alignItems: 'center', gap: 4 }}>
					<Heading as="h3" size="h4" id="petition-strength-title" data-qa="petition-strength-title">
						<Translate value="corgi.petition.starter_dashboard.petition_overview.strength_score.title" />
					</Heading>
					<InfoTooltip data-qa="petition-strength-tooltip" aria-describedby="petition-strength-title">
						<TranslateHtml value="corgi.petition.starter_dashboard.petition_overview.strength_score.tip" />
					</InfoTooltip>
				</Flex>
				<BadgeScore score={data.score} />
				{data.score < 10 && (
					<Link
						data-qa="improve-strength-rating-link"
						to={data.petitionStrengthUrl}
						onClick={actions.improveStrengthLinkClick}
						sx={{ fontSize: '14px' }}
					>
						<Translate value="corgi.petition.starter_dashboard.petition_overview.strength_score.improve_link" />
					</Link>
				)}
			</Flex>
		</Flex>
	);
}
